import { render } from "./HeroiconsSolidFire.vue?vue&type=template&id=e42f476c"
const script = {}

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidFire.vue"]])

export default __exports__